import { render, staticRenderFns } from "./DynamicCommentGalleryList.vue?vue&type=template&id=0365e4fe&scoped=true"
import script from "./DynamicCommentGalleryList.vue?vue&type=script&lang=js"
export * from "./DynamicCommentGalleryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365e4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0365e4fe')) {
      api.createRecord('0365e4fe', component.options)
    } else {
      api.reload('0365e4fe', component.options)
    }
    module.hot.accept("./DynamicCommentGalleryList.vue?vue&type=template&id=0365e4fe&scoped=true", function () {
      api.rerender('0365e4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/dynamic/DynamicCommentGalleryList.vue"
export default component.exports